import { OrganizationGroup } from 'src/domain/organization';

export const LEGACY_DEPARTMENT_VALUE = '__legacy_department__';

export const employeeDepartmentPath = (
    groupId: string,
    groups: OrganizationGroup[],
): string => {
    const groupsById = new Map(groups.map(group => [group.id, group]));
    const names: string[] = [];
    const visited = new Set<string>();
    let group = groupsById.get(groupId);
    while (group && !visited.has(group.id)) {
        visited.add(group.id);
        names.unshift(group.name || group.id);
        group = group.parentId ? groupsById.get(group.parentId) : undefined;
    }
    return names.join(' / ');
};

export const employeeDepartmentUpdate = (
    value: string | undefined,
    changed: boolean,
): { departmentGroupId?: string | null } =>
    changed && value !== LEGACY_DEPARTMENT_VALUE
        ? { departmentGroupId: value || null }
        : {};
